module.exports = __webpack_public_path__ + "static/media/jira_cloud_site_url_example.9699957c.jpeg";